import { makeActionCreator, makeConstantCreator } from '../../utils/reduxUtils';

export const TempPermissionTypes = {
  ...makeConstantCreator('SET_TEMP_PERMISSION', 'CLEAR_TEMP_PERMISSION'),
};
export const setPermission = (id, data) =>
  makeActionCreator(TempPermissionTypes.SET_TEMP_PERMISSION, { id, data });
